export default {
    url: '',
    template: `
        <div class="col00">
            <ui-view></ui-view>
        </div>
    `
};



// WEBPACK FOOTER //
// ./src/app/states/authorized/manage/permissions/index.js